import { ValueFunction } from '../../index';

function methodProduct({args = []}) {
  if (args.every(v => v !== null)) {
    return args.reduce((a,b) => a*b, 1);
  } else {
    return null;
  }
}

export const product = new ValueFunction(
  methodProduct,
  {
    label: 'Product of n-Series',
    description: 'args0 * args1 * ... * argsN',
    parameters: [
      {'name': 'args', 'type': 'array:number'}
    ],
    maxLength: Infinity
  }
);